import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@material-ui/core';
import { Formik, useFormik } from 'formik';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import * as yup from 'yup';
import { ActionHeader, FaqLink } from '..';
// import { ActionHeader } from '../index';
import en from '../../../../lang/en-us';
import { SubmitButton } from '../../../../lib/Button';
import TextInput from '../../../../lib/TextField';
import { sendEmailOTP } from '../../../../redux-store/actions/nct';
import { RootStateType } from '../../../../redux-store/reducers';
import { OTP_ACTIONS, REGISTER_WITH_EMAIL, UPDATE_EMAIL } from '../../../../utils/constants';
import { isError, showHelperText } from '../../commercial/Switch/utils';
import { nextScreen } from '../ChangeMobile/flow';
import EmailRelationship from './EmailRelationship';
const { dashboard, common } = en;
export const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const initialValues = {
    email: '',
    emailRelationship: '',
};

const validationSchema = yup.object({
    email: yup.string().required(common.errors.email.required).email(common.errors.email.regex),
    emailRelationship: yup.string().required(common.errors.relationship.emailRequired),
});

function ChangeEmail(props: any) {
    const { pan, pekrn, mobile, userRegisteredWith, email: registeredEmail } = props;

    const emailFormik = useFormik({
        initialValues,
        onSubmit: async ({ email, emailRelationship }) => {
            if (registeredEmail === email) {
                alert(dashboard.changeEmail.emailError);
                return;
            }
            const action = props?.location?.state?.action || OTP_ACTIONS.NEW_EMAIL_ONINE_OTP;
            const goTo = nextScreen(props.match.path, 'email');
            try {
                let res = await props.sendEmailOTP({
                    email,
                    pan,
                    pekrn,
                    mobile,
                    action,
                });
                props.history.push(goTo, {
                    enteredEmail: email,
                    emailRelationship: emailRelationship,
                    ...(props?.location?.state || {}),
                    action,
                    ...(res || {}).body,
                });
            } catch (err: any) {
                alert(err.message);
            }
        },
        validationSchema,
    });

    // Avoid direct navigation to this page if user is registered through email
    useEffect(() => {
        // This page should not be opened by entering the url if registered with Email
        // This page is the first page in the flow, if user is registered with mobile number.
        // But this page comes as 3rd page in the flow when user is email registered
        if (userRegisteredWith == REGISTER_WITH_EMAIL) {
            if (!props.location.state) {
                props.history.replace('/');
                return;
            }
        }
    }, []);

    return (
        <div className="curved-bg">
            <ActionHeader header={dashboard.changeEmail.changeEmailHeading} />
            <div className="curved-bg-content">
                <img className="change-email-img" src="/images/change-email-img.png" alt="icon" />
                <div className="curved-bg-content-inner">
                    <div className="curved-bg-content-inner-top change-email-top">
                        <h3 className="subheading">
                            {dashboard.changeEmail.subHeading}
                            <span>{dashboard.changeEmail.subHeadingSpan}</span>
                        </h3>
                        <p>{dashboard.changeEmail.subHeadingInfo}</p>
                        <TextInput
                            variant="outlined"
                            onChange={emailFormik.handleChange}
                            label="Enter Here"
                            error={isError(emailFormik, 'email')}
                            helperText={showHelperText(emailFormik, 'email')}
                            value={emailFormik.values.email}
                            name="email"
                        />
                        <EmailRelationship emailFormik={emailFormik} />
                    </div>
                    <FaqLink section={UPDATE_EMAIL} history={props.history} />
                    <div className="curved-bg-content-inner-bottom">
                        <SubmitButton
                            label={dashboard.changeEmail.buttonText}
                            onClick={emailFormik.handleSubmit as any}
                            className="customBtn"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), { sendEmailOTP })(
    ChangeEmail,
);
